import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType } from "__generated__/graphql";
import ManualCalculationMethodForm from "view/calculationmethods/components/form/ManualCalculationMethodForm";
import ManualCalculationMethodDetails from "view/calculationmethods/components/details/ManualCalculationMethodDetails";

export const ManualSchema: RegistryItem = {
	[CalculationMethodType.Manual]: {
		Form: ManualCalculationMethodForm,
		Details: ManualCalculationMethodDetails,
		toInput: (form) => ({
			manualCalculationMethodInput: {
				id: form.id ?? undefined,
				description: form.description ?? undefined,
				customUnit: form.customUnit ?? undefined,
			},
		}),
	},
};
